export default "__VITE_ASSET__8a7730b5__"